// Canonical product-agnostic experience event contract (arch doc §3.3).
// WAVE 1 ships ONLY these JSDoc typedefs plus an INERT event-bus interface.
// No producers, no consumers, no persistence are wired in Wave 1.

/**
 * @typedef {Object} ExperienceEntity
 * @property {string} type
 * @property {string} id
 */

/**
 * @typedef {Object} ExperienceEvent
 * @property {string} source                         Producer identifier (e.g. 'tla.journey').
 * @property {string} type                           Dot-namespaced verb, e.g. 'journey.task.completed'.
 * @property {ExperienceEntity} entity               The subject entity of the event.
 * @property {string} actor_id                       Who performed the action.
 * @property {string} subject_id                     Whose history it belongs to; surface a moment only
 *                                                   when actor_id === subject_id (D10, self-initiated only).
 * @property {string} occurred_at                    ISO-8601 UTC timestamp.
 * @property {Object} payload                        Whitelisted keys only; never free-form PII.
 * @property {'normal'|'sensitive'|'silent'} sensitivity  Owned by the Safety gate (§8); fails closed.
 */

/**
 * Create the inert Wave 1 event bus. `publish` is a no-op sink and `subscribe` returns
 * a no-op unsubscribe. This exists so downstream waves can wire producers/consumers
 * against a stable interface without any Wave 1 behavior.
 * @returns {{ publish: (event: ExperienceEvent) => void, subscribe: (fn: Function) => (() => void) }}
 */
export function createInertEventBus() {
  return {
    publish() {
      /* inert in Wave 1: no producers, no consumers, no persistence */
    },
    subscribe() {
      return () => {};
    },
  };
}
